import { render, staticRenderFns } from "./Staffing.vue?vue&type=template&id=2ae63830&scoped=true"
import script from "./Staffing.vue?vue&type=script&lang=js"
export * from "./Staffing.vue?vue&type=script&lang=js"
import style0 from "./Staffing.vue?vue&type=style&index=0&id=2ae63830&prod&scoped=true&lang=css"
import style1 from "./Staffing.vue?vue&type=style&index=1&id=2ae63830&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae63830",
  null
  
)

export default component.exports